/**
 * @generated SignedSource<<46215f6cdc8b85e17d7dd057c80add5a>>
 * @relayHash f47bc93d7998ea210ac691b605f5b35d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID af9ab646d72da9776393b5dea7993049fd837b63b73b763c24ae60f979741ab0

import type { ConcreteRequest, Query } from 'relay-runtime';
export type FeedEventType = "COMMENT" | "CREATE" | "EDIT" | "EDITLIVE" | "PUBLISHLIVE" | "%future added value";
export type FeedItemSourceType = "PERSON" | "SPACE" | "%future added value";
export type useFollowingFeedWithSortByStorageFeedContentQuery$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  includeGeneratedBy?: boolean | null | undefined;
  sortBy?: string | null | undefined;
};
export type useFollowingFeedWithSortByStorageFeedContentQuery$data = {
  readonly feed: {
    readonly nodes: ReadonlyArray<{
      readonly content: {
        readonly contentProperties?: {
          readonly latest: {
            readonly generatedBy: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly emoji: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly excerpt: string;
        readonly history: {
          readonly createdBy: {
            readonly accountId?: string | null | undefined;
            readonly displayName: string | null | undefined;
            readonly profilePicture: {
              readonly path: string;
            } | null | undefined;
            readonly type: string | null | undefined;
          } | null | undefined;
          readonly createdDate: string | null | undefined;
          readonly ownedBy: {
            readonly accountId?: string | null | undefined;
            readonly displayName: string | null | undefined;
            readonly profilePicture: {
              readonly path: string;
            } | null | undefined;
            readonly type: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly id: string | null | undefined;
        readonly links: {
          readonly webui: string | null | undefined;
        } | null | undefined;
        readonly metadata: {
          readonly comments: {
            readonly commentsCount: number | null | undefined;
          } | null | undefined;
          readonly currentuser: {
            readonly favourited: {
              readonly isFavourite: boolean | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly lastModifiedDate: string | null | undefined;
        };
        readonly space: {
          readonly alias: string | null | undefined;
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly subType: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined;
      readonly recentActionsCount: number;
      readonly source: ReadonlyArray<FeedItemSourceType>;
      readonly summaryLineUpdate: {
        readonly comment?: {
          readonly body: {
            readonly value: string;
          };
          readonly id: string;
          readonly links: {
            readonly webui: string | null | undefined;
          };
          readonly location: {
            readonly inlineText?: string | null | undefined;
            readonly type: string;
          };
        } | null | undefined;
        readonly datetime: string;
        readonly groupSize: number;
        readonly type: FeedEventType;
        readonly user?: {
          readonly accountId?: string | null | undefined;
          readonly displayName: string | null | undefined;
          readonly profilePicture: {
            readonly path: string;
          } | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
        readonly version?: number;
      };
    }>;
    readonly pageInfo: {
      readonly endCursor: string;
      readonly hasNextPage: boolean;
    };
  } | null | undefined;
  readonly getFeedUserConfig: {
    readonly servingRecommendations: boolean;
    readonly spaces: ReadonlyArray<{
      readonly id: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly users: ReadonlyArray<{
      readonly accountId?: string | null | undefined;
      readonly displayName: string | null | undefined;
      readonly profilePicture: {
        readonly path: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useFollowingFeedWithSortByStorageFeedContentQuery = {
  response: useFollowingFeedWithSortByStorageFeedContentQuery$data;
  variables: useFollowingFeedWithSortByStorageFeedContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeGeneratedBy"
},
v3 = {
  "defaultValue": "relevant",
  "kind": "LocalArgument",
  "name": "sortBy"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "sortBy",
    "variableName": "sortBy"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "recentActionsCount"
},
v6 = {
  "kind": "ScalarField",
  "name": "datetime"
},
v7 = {
  "kind": "ScalarField",
  "name": "type"
},
v8 = {
  "kind": "ScalarField",
  "name": "groupSize"
},
v9 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v10 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v11 = [
  {
    "kind": "ScalarField",
    "name": "accountId"
  }
],
v12 = {
  "kind": "InlineFragment",
  "selections": (v11/*: any*/),
  "type": "KnownUser"
},
v13 = {
  "kind": "InlineFragment",
  "selections": (v11/*: any*/),
  "type": "UnknownUser"
},
v14 = [
  (v7/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/)
],
v15 = {
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v14/*: any*/)
},
v16 = {
  "kind": "ScalarField",
  "name": "version"
},
v17 = [
  (v16/*: any*/),
  (v15/*: any*/)
],
v18 = {
  "kind": "ScalarField",
  "name": "id"
},
v19 = [
  {
    "kind": "ScalarField",
    "name": "webui"
  }
],
v20 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v19/*: any*/)
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "inlineText"
    }
  ],
  "type": "InlineComment"
},
v22 = {
  "kind": "ScalarField",
  "name": "value"
},
v23 = {
  "args": [
    {
      "kind": "Literal",
      "name": "representation",
      "value": "ATLAS_DOC_FORMAT"
    }
  ],
  "concreteType": "DocumentBody",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    (v22/*: any*/)
  ],
  "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
},
v24 = {
  "kind": "ScalarField",
  "name": "source"
},
v25 = {
  "kind": "ScalarField",
  "name": "title"
},
v26 = {
  "kind": "ScalarField",
  "name": "subType"
},
v27 = {
  "alias": "emoji",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "emoji-title-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v18/*: any*/),
        (v22/*: any*/)
      ]
    }
  ],
  "storageKey": "properties(key:\"emoji-title-published\")"
},
v28 = {
  "condition": "includeGeneratedBy",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "ContentProperties",
      "kind": "LinkedField",
      "name": "contentProperties",
      "plural": false,
      "selections": [
        {
          "concreteType": "PublishedContentProperties",
          "kind": "LinkedField",
          "name": "latest",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "generatedBy"
            }
          ]
        }
      ]
    }
  ]
},
v29 = {
  "args": [
    {
      "kind": "Literal",
      "name": "length",
      "value": 350
    }
  ],
  "kind": "ScalarField",
  "name": "excerpt",
  "storageKey": "excerpt(length:350)"
},
v30 = {
  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v19/*: any*/)
},
v31 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v32 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "alias"
    },
    (v18/*: any*/),
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ]
},
v33 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
      "kind": "LinkedField",
      "name": "comments",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "commentsCount"
        }
      ]
    },
    {
      "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
      "kind": "LinkedField",
      "name": "currentuser",
      "plural": false,
      "selections": [
        {
          "concreteType": "FavouritedSummary",
          "kind": "LinkedField",
          "name": "favourited",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isFavourite"
            }
          ]
        }
      ]
    }
  ]
},
v34 = {
  "concreteType": "FeedPageInformation",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v35 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "spaces",
  "plural": true,
  "selections": [
    (v18/*: any*/)
  ]
},
v36 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "ABSOLUTE"
        }
      ],
      "kind": "ScalarField",
      "name": "path",
      "storageKey": "path(type:\"ABSOLUTE\")"
    }
  ]
},
v37 = {
  "kind": "ScalarField",
  "name": "servingRecommendations"
},
v38 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v39 = [
  (v38/*: any*/),
  (v7/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/)
],
v40 = {
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v39/*: any*/)
},
v41 = [
  (v16/*: any*/),
  (v40/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useFollowingFeedWithSortByStorageFeedContentQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "PaginatedFeed",
        "kind": "LinkedField",
        "name": "feed",
        "plural": false,
        "selections": [
          {
            "concreteType": "FeedItem",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "summaryLineUpdate",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v15/*: any*/)
                    ],
                    "type": "FeedEventCreate"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v17/*: any*/),
                    "type": "FeedEventEdit"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v17/*: any*/),
                    "type": "FeedEventEditLive"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v17/*: any*/),
                    "type": "FeedEventPublishLive"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v15/*: any*/),
                      {
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "comment",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          (v20/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v21/*: any*/)
                            ]
                          },
                          (v23/*: any*/)
                        ]
                      }
                    ],
                    "type": "FeedEventComment"
                  }
                ]
              },
              (v24/*: any*/),
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v25/*: any*/),
                  (v18/*: any*/),
                  (v7/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v14/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v12/*: any*/)
                        ]
                      },
                      (v31/*: any*/)
                    ]
                  },
                  (v32/*: any*/),
                  (v33/*: any*/)
                ]
              }
            ]
          },
          (v34/*: any*/)
        ]
      },
      {
        "concreteType": "FollowingFeedGetUserConfig",
        "kind": "LinkedField",
        "name": "getFeedUserConfig",
        "plural": false,
        "selections": [
          (v35/*: any*/),
          {
            "kind": "LinkedField",
            "name": "users",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v36/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/)
            ]
          },
          (v37/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useFollowingFeedWithSortByStorageFeedContentQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "PaginatedFeed",
        "kind": "LinkedField",
        "name": "feed",
        "plural": false,
        "selections": [
          {
            "concreteType": "FeedItem",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "summaryLineUpdate",
                "plural": false,
                "selections": [
                  (v38/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v40/*: any*/)
                    ],
                    "type": "FeedEventCreate"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v41/*: any*/),
                    "type": "FeedEventEdit"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v41/*: any*/),
                    "type": "FeedEventEditLive"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v41/*: any*/),
                    "type": "FeedEventPublishLive"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v40/*: any*/),
                      {
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "comment",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          (v20/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                              (v38/*: any*/),
                              (v7/*: any*/),
                              (v21/*: any*/)
                            ]
                          },
                          (v23/*: any*/)
                        ]
                      }
                    ],
                    "type": "FeedEventComment"
                  }
                ]
              },
              (v24/*: any*/),
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v25/*: any*/),
                  (v18/*: any*/),
                  (v7/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v39/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": [
                          (v38/*: any*/),
                          (v7/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v12/*: any*/)
                        ]
                      },
                      (v31/*: any*/)
                    ]
                  },
                  (v32/*: any*/),
                  (v33/*: any*/)
                ]
              }
            ]
          },
          (v34/*: any*/)
        ]
      },
      {
        "concreteType": "FollowingFeedGetUserConfig",
        "kind": "LinkedField",
        "name": "getFeedUserConfig",
        "plural": false,
        "selections": [
          (v35/*: any*/),
          {
            "kind": "LinkedField",
            "name": "users",
            "plural": true,
            "selections": [
              (v38/*: any*/),
              (v9/*: any*/),
              (v36/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/)
            ]
          },
          (v37/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f47bc93d7998ea210ac691b605f5b35d",
    "id": "af9ab646d72da9776393b5dea7993049fd837b63b73b763c24ae60f979741ab0",
    "metadata": {},
    "name": "useFollowingFeedWithSortByStorageFeedContentQuery",
    "operationKind": "query",
    "text": "query useFollowingFeedWithSortByStorageFeedContentQuery($first:Int,$after:String,$sortBy:String=\"relevant\",$includeGeneratedBy:Boolean=false){feed(first:$first,after:$after,sortBy:$sortBy){nodes{recentActionsCount,summaryLineUpdate{__typename,datetime,type,groupSize,...on FeedEventCreate{user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventEdit{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventEditLive{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventPublishLive{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventComment{user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},comment{id,links{webui},location{__typename,type,...on InlineComment{inlineText}},body(representation:ATLAS_DOC_FORMAT){value}}}},source,content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},contentProperties@include(if:$includeGeneratedBy){latest{generatedBy}},excerpt(length:350),links{webui},history{createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}},createdDate},space{alias,id,key,name},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}}}},pageInfo{hasNextPage,endCursor}},getFeedUserConfig{spaces{id},users{__typename,displayName,profilePicture{path(type:ABSOLUTE)},...on KnownUser{accountId},...on UnknownUser{accountId}},servingRecommendations}}"
  }
};
})();

(node as any).hash = "c9afd79ecba25f914402168c882a0f16";

export default node;
